/**
 * Cart Drawer Engraving Modal
 * Opens an engraving popup directly in the cart drawer instead of redirecting.
 * Adds engraving as an independent product to the cart via the Cart API.
 */
(function () {
  'use strict';

  var MODAL_ID = 'CartEngravingModalOverlay';
  var engravingVariantId = null;
  var modalElement = null;

  function getConfig() {
    var el = document.getElementById('cart-engraving-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function createModal(config) {
    if (document.getElementById(MODAL_ID)) return;

    var maxChars = config.maxChars || 10;
    var overlay = document.createElement('div');
    overlay.id = MODAL_ID;
    overlay.className = 'cart-engraving-modal-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    overlay.innerHTML =
      '<div class="cart-engraving-modal">' +
        '<div class="cart-engraving-modal__header">' +
          '<h2 class="cart-engraving-modal__title">' + (config.modalTitle || 'Individuelle Gravur') + '</h2>' +
          '<button type="button" class="cart-engraving-modal__close" id="cartEngravingClose" aria-label="' + (config.cancel || 'Close') + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
              '<line x1="18" y1="6" x2="6" y2="18"></line>' +
              '<line x1="6" y1="6" x2="18" y2="18"></line>' +
            '</svg>' +
          '</button>' +
        '</div>' +
        '<div class="cart-engraving-modal__body">' +
          '<label for="cartEngravingInput" class="cart-engraving-modal__label">' + (config.modalLabel || '') + '</label>' +
          '<div class="cart-engraving-modal__input-wrapper">' +
            '<input type="text" id="cartEngravingInput" class="cart-engraving-modal__input" placeholder="' + (config.placeholder || '') + '" maxlength="' + maxChars + '" autocomplete="off">' +
            '<span class="cart-engraving-modal__char-counter"><span id="cartEngravingCharCount">0</span>/' + maxChars + '</span>' +
          '</div>' +
          '<p class="cart-engraving-modal__hint">' + (config.modalHint || '') + '</p>' +
        '</div>' +
        '<div class="cart-engraving-modal__footer">' +
          '<button type="button" class="cart-engraving-modal__btn cart-engraving-modal__btn--confirm" id="cartEngravingConfirm" disabled>' +
            (config.confirm || 'Confirm') +
          '</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);
    modalElement = overlay;

    // Close on overlay click
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    // Close button
    overlay.querySelector('#cartEngravingClose').addEventListener('click', closeModal);

    // Input handling
    var input = overlay.querySelector('#cartEngravingInput');
    var charCount = overlay.querySelector('#cartEngravingCharCount');
    var confirmBtn = overlay.querySelector('#cartEngravingConfirm');

    input.addEventListener('input', function () {
      var len = input.value.length;
      charCount.textContent = len;

      var counter = charCount.parentElement;
      counter.classList.remove('warning', 'error');
      if (len >= maxChars) {
        counter.classList.add('error');
      } else if (len >= maxChars - 2) {
        counter.classList.add('warning');
      }

      confirmBtn.disabled = !input.value.trim() || len > maxChars;

      if (len > maxChars) {
        input.classList.add('error');
      } else {
        input.classList.remove('error');
      }
    });

    // Confirm button
    confirmBtn.addEventListener('click', function () {
      var text = input.value.trim();
      if (!text || text.length > maxChars) return;
      addEngravingToCart(text, config);
    });

    // ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalElement && modalElement.classList.contains('active')) {
        closeModal();
      }
    });
  }

  function openModal() {
    if (!modalElement) return;
    var input = modalElement.querySelector('#cartEngravingInput');
    var charCount = modalElement.querySelector('#cartEngravingCharCount');
    var confirmBtn = modalElement.querySelector('#cartEngravingConfirm');

    // Reset
    if (input) {
      input.value = '';
      input.classList.remove('error');
    }
    if (charCount) {
      charCount.textContent = '0';
      charCount.parentElement.classList.remove('warning', 'error');
    }
    if (confirmBtn) confirmBtn.disabled = true;

    modalElement.classList.add('active');
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = (window.innerWidth - document.documentElement.clientWidth) + 'px';

    setTimeout(function () {
      if (input) input.focus();
    }, 300);
  }

  function closeModal() {
    if (!modalElement) return;
    modalElement.classList.remove('active');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  function fetchVariantId(handle) {
    if (engravingVariantId) return Promise.resolve(engravingVariantId);
    return fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('Product not found: ' + r.status);
        return r.json();
      })
      .then(function (product) {
        if (product && product.variants && product.variants.length > 0) {
          engravingVariantId = product.variants[0].id;
        }
        return engravingVariantId;
      })
      .catch(function (err) {
        console.warn('[Cart Engraving] Could not fetch engraving product:', err.message || err);
        // Reset so next call retries instead of returning cached null
        engravingVariantId = null;
        return null;
      });
  }

  function addEngravingToCart(text, config) {
    var confirmBtn = modalElement.querySelector('#cartEngravingConfirm');
    if (confirmBtn) {
      confirmBtn.disabled = true;
      confirmBtn.textContent = '...';
    }

    var handle = config.productHandle || 'gravur';

    // Always (re-)fetch variant ID to avoid stale/null values
    fetchVariantId(handle).then(function (variantId) {
      if (!variantId) {
        showNotification(config.errorUnavailable || 'Engraving service unavailable.', 'error');
        resetConfirmButton(confirmBtn, config);
        closeModal();
        return;
      }

      var properties = {};
      properties[config.cartPropertyText || 'Engraving'] = text;

      var formData = {
        items: [{
          id: variantId,
          quantity: 1,
          properties: properties
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Failed to add engraving');
          return response.json();
        })
        .then(function () {
          closeModal();
          // Immediately hide the engraving hint (don't wait for section refresh)
          hideEngravingHint();
          refreshCartDrawer();
        })
        .catch(function () {
          showNotification(config.errorAddFailed || 'Error adding engraving.', 'error');
          resetConfirmButton(confirmBtn, config);
          closeModal();
        });
    });
  }

  function resetConfirmButton(btn, config) {
    if (btn) {
      btn.disabled = false;
      btn.textContent = config.confirm || 'Confirm';
    }
  }

  function refreshCartDrawer() {
    // Fetch the updated cart-drawer section via Shopify Section Rendering API
    var sectionId = 'cart-drawer';
    fetch('/?sections=' + sectionId)
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections[sectionId];
        if (!html) return;

        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newDrawerInner = parsed.querySelector('.drawer__inner');
        var currentDrawerInner = document.querySelector('cart-drawer .drawer__inner');

        if (newDrawerInner && currentDrawerInner) {
          currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
        }

        // Update cart icon bubble
        var newBubble = parsed.querySelector('.cart-count-bubble');
        var currentBubble = document.querySelector('.cart-count-bubble');
        if (newBubble && currentBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
        } else if (newBubble && !currentBubble) {
          var iconLink = document.querySelector('#cart-icon-bubble');
          if (iconLink) {
            iconLink.appendChild(newBubble.cloneNode(true));
          }
        }

        // Also re-inject scripts if present
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.querySelectorAll('.drawer__inner script').forEach(function (oldScript) {
            var newScript = document.createElement('script');
            Array.from(oldScript.attributes).forEach(function (attr) {
              newScript.setAttribute(attr.name, attr.value);
            });
            newScript.textContent = oldScript.textContent;
            oldScript.parentNode.replaceChild(newScript, oldScript);
          });

          // Remove is-empty if it had it
          cartDrawer.classList.remove('is-empty');
        }
      })
      .catch(function () {
        // Fallback: reload the page
        window.location.reload();
      });

    // Dispatch events for other components
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { source: 'cart-engraving' }
    }));
  }

  function hideEngravingHint() {
    document.querySelectorAll('.cart-drawer__engraving-hint').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  /**
   * Check if engraving is already in cart and hide the hint if so.
   * This covers cases where engraving was added from the product page
   * and the cart drawer hasn't been server-re-rendered yet.
   */
  function checkCartForEngraving(productHandle) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasEngraving = cart.items.some(function (item) {
          return item.handle === productHandle;
        });
        if (hasEngraving) {
          hideEngravingHint();
        }
      })
      .catch(function () {});
  }

  function showNotification(message, type) {
    var existing = document.querySelector('.cart-engraving-notification');
    if (existing) existing.remove();

    var el = document.createElement('div');
    el.className = 'cart-engraving-notification cart-engraving-notification--' + type;
    el.setAttribute('role', 'alert');
    el.innerHTML = '<span>' + message + '</span><button aria-label="Close" onclick="this.parentElement.remove()">&times;</button>';
    document.body.appendChild(el);

    setTimeout(function () {
      if (el.parentNode) el.remove();
    }, 4000);
  }

  // Initialize: use event delegation so it works after cart drawer re-renders
  function init() {
    var config = getConfig();
    if (!config) return;

    var handle = config.productHandle || 'gravur';

    // Pre-fetch the engraving variant ID
    fetchVariantId(handle);

    // Create the modal (appended to body, outside cart drawer re-render zone)
    createModal(config);

    // Check on init if engraving is already in cart
    checkCartForEngraving(handle);

    // Re-check whenever the cart drawer becomes visible (e.g. opened)
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'class' && cartDrawer.classList.contains('active')) {
            checkCartForEngraving(handle);
            break;
          }
        }
      });
      observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }

    // Also listen for cart:updated events from other components
    document.addEventListener('cart:updated', function () {
      checkCartForEngraving(handle);
    });

    // Event delegation for the trigger button
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cart-engraving-trigger]');
      if (trigger) {
        e.preventDefault();
        openModal();
      }
    });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
